export default __webpack_public_path__ + "static/media/Group 626086.10558e71.svg";